module.exports = __webpack_public_path__ + "assets/img/20.a66a96b9.png";